import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import initDatadogRUM from 'util/datadogScript';

(async () => {
  if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
    initDatadogRUM();
  }

  const container = document.getElementById('root');
  if (!container) throw new Error('Failed to find the root element');
  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
})();
